const getVoucherToggleStyles = theme => ({
  fontSize: theme.toRem(theme.typography.fontSize.M),
  display: 'inline-flex',
  marginBottom: theme.spacing(2),
  cursor: 'pointer',
  [theme.mediaQuery('tabletLarge')]: {
    display: 'none'
  }
});
const getTitleStyles = theme => ({
  display: 'none',
  [theme.mediaQuery('tabletLarge')]: {
    display: 'block',
    fontSize: theme.toRem(theme.typography.fontSize.S),
    color: theme.palette.secondary.main
  }
});
const getFormControlsContainerStyles = isOpened => theme => ({
  height: isOpened ? 'auto' : '0',
  maxHeight: isOpened ? '100px' : '0',
  [theme.mediaQuery('tabletLarge')]: {
    height: 'auto',
    maxHeight: 'none'
  },
  overflow: 'hidden',
  transition: 'all 200ms ease',
  button: {
    marginTop: 0
  }
});

export { getFormControlsContainerStyles, getTitleStyles, getVoucherToggleStyles };
//# sourceMappingURL=PaymentVoucherStyles.js.map
